import { render, staticRenderFns } from "./ProjectileMotionViz.vue?vue&type=template&id=613a5eaf&scoped=true"
import script from "./ProjectileMotionViz.vue?vue&type=script&lang=js"
export * from "./ProjectileMotionViz.vue?vue&type=script&lang=js"
import style0 from "./ProjectileMotionViz.vue?vue&type=style&index=0&id=613a5eaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a5eaf",
  null
  
)

export default component.exports